import React, { useEffect, useRef } from 'react';
import { ReactComponent as Logo } from 'img/logo.svg';
import { ReactComponent as Close } from 'img/btn-close.svg';
import './Modal.scss';
// import Dimmer from '@components/Dimmer';
import Button from '@components/Button';
import LogoAndTitle from '@components/Logo/Logo';

interface ModalBaseProps {
  title?: string;
  // open?: boolean;
  description: React.ReactNode;
  buttonLabel?: {
    left?: string;
    right?: string;
    leftImage?: string;
    rightImage?: string;
  };
  onLeftClick?: () => void;
  close?: () => void;
  inside?: boolean;
  useHeader?: boolean;
  useHeaderClose?: boolean;
  contentStyle?: React.CSSProperties;
  dimStyle?: React.CSSProperties;
  additionalButtons?: React.ReactNode;
  className?: string;
  headerContent?: React.ReactNode;
}

export interface AlertProps extends ModalBaseProps {
  type: 'alert';
  onLeftClick: () => void;
  onRightClick?: never;
  useHeader?: true;
}

export interface DialogProps extends ModalBaseProps {
  type: 'dialog';
  onLeftClick: () => void;
  onRightClick: () => void;
  useHeader?: true;
  useHeaderClose?: true;
}

export interface ModalPageProps extends ModalBaseProps {
  type: 'page';
  onLeftClick?: never;
  onRightClick?: never;
  useHeader?: boolean;
}

function Modal(props: AlertProps | DialogProps | ModalPageProps) {
  const {
    // open,
    type,
    title,
    description,
    onLeftClick,
    onRightClick,
    buttonLabel,
    close,
    inside = false,
    useHeader = type === 'alert' || type === 'dialog' || type !== 'page',
    useHeaderClose = type === 'dialog',
    contentStyle,
    dimStyle,
    additionalButtons,
    headerContent,
    className,
  } = props;

  const handleClose = () => {
    if (close) close();
  };

  const renderButtons = () => {
    if (type === 'page') return null;
    if (type === 'dialog') {
      return (
        <Button.InlineGroup
          buttonClassNames={[
            'shared-button modal-action-button',
            'shared-button modal-action-button modal-action-button-primary',
          ]}
          onClicks={[onLeftClick, props.onRightClick]}
          justify="end"
          contents={[
            buttonLabel?.leftImage ? (
              <span className="button-content">
                <img src={buttonLabel.leftImage} alt="" />
                {buttonLabel?.left ?? 'No'}
              </span>
            ) : (
              <span>{buttonLabel?.left ?? 'No'}</span>
            ),
            buttonLabel?.rightImage ? (
              <span className="button-content">
                <img src={buttonLabel.rightImage} alt="" />
                {buttonLabel?.right ?? 'Yes'}
              </span>
            ) : (
              <span>{buttonLabel?.right ?? 'Yes'}</span>
            ),
          ]}
        />
      );
    }
    return <Button onClick={onLeftClick}>{buttonLabel?.left ?? 'OK'}</Button>;
  };

  return (
    <div className={`modal-container${className ? ` ${className}` : ''}`}>
      {/* {useHeader && (
        <div className="modal-container-header">
          <div className="modal-container-header-section">
            <LogoAndTitle goList={false}/>
          </div>
          <Close
            className='modal-container-header-close default-svg-color'
            onClick={handleClose}
          />
        </div>
      )} */}
      {/* <div className='modal-container-content'> */}
        {description}
        {type !== 'page' && (
          <div className='modal-container-content-btn'>
            {renderButtons()}
          </div>
        )}
      {/* </div> */}
    </div>
  );
}

function TextDescription({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={`modal-text-description${className ? ` ${className}` : ''}`}>
      {children}
    </div>
  );
}

Modal.TextDescription = TextDescription;

export default Modal;
